var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDelete = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B6C0C4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12a9.6 9.6 0 1 0-19.2 0M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12M2.4 12a9.6 9.6 0 1 0 19.2 0m2.4 0c0 6.627-5.373 12-12 12S0 18.627 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.41 8 2.73 2.732L14.874 8a1 1 0 0 1 1.32-.083l.095.083a1 1 0 0 1 0 1.414l-2.733 2.732 2.733 2.732a1 1 0 0 1-1.415 1.415l-2.732-2.733-2.732 2.733a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1 0-1.415l2.732-2.732-2.732-2.732A1 1 0 0 1 9.409 8z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-delete.ab1a22a3316e3a927eeca679f3ca9faf.svg";